import { useEffect, useState } from 'react';

function ExamsTimer() {
  const [timerVisible, setTimerVisible] = useState(true);
  let timerInterval;

  var endTime = new Date();
  endTime.setHours(endTime.getHours() + 3);

  useEffect(() => {
    // Update the timer every second - always runs regardless of visibility
    timerInterval = setInterval(updateTimer, 1000);

    // Cleanup function to clear the interval when the component unmounts
    return () => {
      clearInterval(timerInterval);
    };
  }, []);

  function updateTimer() {
    // Get the current time
    var currentTime = new Date();

    // Calculate the remaining time in seconds
    var remainingTime = Math.floor((endTime - currentTime) / 1000);

    // Check if the time has elapsed
    if (remainingTime <= 0) {
      clearInterval(timerInterval);
      alert("Τέλος χρόνου!");
      
      // Submit the form
      document.getElementById("form").submit();
      
      return;
    }

    // Calculate the hours, minutes, and seconds
    var hours = Math.floor(remainingTime / 3600);
    var minutes = Math.floor((remainingTime % 3600) / 60);
    var seconds = remainingTime % 60;

    // Format the time as HH:MM:SS
    var timeString = padZero(hours) + ":" + padZero(minutes) + ":" + padZero(seconds);

    // Update the timer element
    const timerElement = document.getElementById("timer");
    if (timerElement) {
      timerElement.innerHTML = "Χρόνος που απομένει: " + timeString;
    }

    // Check if 1 hour is remaining
    if (hours === 1 && minutes === 0 && seconds === 0) {
      alert("Απομένει 1 ώρα!");
    }
    
    // Check if 10 minutes are remaining
    if (hours === 0 && minutes === 10 && seconds === 0) {
      alert("Απομένουν 10 λεπτά!");
    }
  }

  function padZero(value) {
    return value < 10 ? "0" + value : value;
  }

  return (
    <div style={{textAlign:"center"}} >
      <div id="timer" style={{textAlign:"center", display: timerVisible ? "inline-block" : "none"}}></div>
      <button 
        type="button"
        onClick={() => setTimerVisible(!timerVisible)}
        className="timer-toggle-btn"
        style={{marginTop: "10px"}}
      >
        {timerVisible ? "👁️ Απόκρυψη Χρονομέτρου" : "👁️ Εμφάνιση Χρονομέτρου"}
      </button>
    </div>
  )
}

export default ExamsTimer;
